import { render, staticRenderFns } from "./AccountDelete.vue?vue&type=template&id=fe78838e&scoped=true"
import script from "./AccountDelete.vue?vue&type=script&lang=js"
export * from "./AccountDelete.vue?vue&type=script&lang=js"
import style0 from "./AccountDelete.vue?vue&type=style&index=0&id=fe78838e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe78838e",
  null
  
)

export default component.exports